<template>
  <div id="salesmanList" v-loading="exportLoading">
    <el-card>
      <!-- 查询选项 -->
      <Form class="salesmanForm" :label-width="160">
        <FormItem class="form_item" :label="$t('projectName1')">
          <Input clearable v-model="projectName" :placeholder="$t('enter')"/>
        </FormItem>
        <!-- <FormItem class="form_item" :label="$t('projectNumber1')">
          <Input clearable v-model="projectNumber" :placeholder="$t('enter')"/>
        </FormItem> -->
        <FormItem class="form_item" :label="$t('projectID')">
          <Input clearable v-model="upstreamSystemId" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('serviceContractNo2')">
          <Input clearable v-model="serviceContractNo" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('projectType1')">
          <el-select filterable v-model="projectType" clearable :placeholder="$t('select')">
            <el-option v-for="item in ProjectTypeList" :key="item.sysDesc" :label="item.sysValue" :value="item.sysDesc">
            </el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('country1')">
          <el-select filterable v-model="country" clearable :placeholder="$t('select')">
            <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('customerName1')">
          <Input clearable v-model="customerName" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('projectManager1')" v-if="queryShow">
          <el-select v-model="projectManager" clearable filterable remote :remote-method="value => remoteMethod('ProjectManagerList', value)" :placeholder="$t('select')">
            <el-option v-for="(item, index) in ProjectManagerList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('projectStatus1')" v-if="queryShow">
          <el-select v-model="projectStatus" clearable>
            <el-option v-for="item in StatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('projectStartDate1')" v-if="queryShow">
          <el-date-picker v-model="projectStartDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('selectdate')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('projectEndDate1')" v-if="queryShow">
          <el-date-picker v-model="projectEndDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('selectdate')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('finalBeneficialDept1')" v-if="queryShow">
          <el-select v-model="finalBeneficialDept" clearable filterable remote :remote-method="value => remoteMethodDept('FinalBeneficialDeptList', value)">
            <el-option v-for="(item, index) in FinalBeneficialDeptList" :key="index" :label="item.deptEnName" :value="item.deptEnName"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('csiAccountCode1')" v-if="queryShow">
          <Input clearable v-model="csiAccountCode" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('beltAndRoad1')" v-if="queryShow">
          <el-select v-model="beltAndRoad" clearable>
            <el-option v-for="item in BeltAndRoadList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('department1')" v-if="queryShow">
          <el-select filterable v-model="department" clearable>
            <el-option v-for="item in DeptList" :key="item.deptCode" :label="item.deptEnName" :value="item.deptCode"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('presaleKeyProject1')" v-if="queryShow">
          <el-select v-model="presaleKeyProject" clearable>
            <el-option v-for="item in PresaleKeyProjectList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('postsaleKeyProject2')" v-if="queryShow">
          <el-select v-model="postsaleKeyProject" clearable>
            <el-option v-for="item in PostsaleKeyProjectList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </FormItem>
        <div class="buttonDiv">
          <el-button type="primary" size="mini" @click="advancedFilter">{{$t('advancedFilter')}}</el-button>
          <el-button type="primary" size="mini" @click="searchProjectByPage" :loading="searchLoading">{{$t('search')}}</el-button>
          <el-button type="primary" size="mini" @click="sourceInfo">{{$t('projectPool')}}</el-button>
          <el-button v-has="{class:'projectBatch'}" type="primary" size="mini" @click="batchInfo">{{$t('batchEdit')}}</el-button>
          <el-button v-has="{class:'projectExport'}" type="primary" size="mini" @click="exportExcel">{{$t('export')}}</el-button>
          <el-button v-has="{class:'projectAdd'}" type="primary" size="mini" @click="addInfo">{{$t('add')}}</el-button>
          <el-button v-has="{class:'projectBatchTransfer'}" type="primary" size="mini" @click="batchTransfer">Bacth Transfer</el-button>
        </div>
      </Form>
      
      <div class="contentTableDiv">
        <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width:100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="id" v-if="false"></el-table-column> 
          <!-- <el-table-column prop="projectNumber" :label="$t('projectNumber')" align="center" width="170" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleNavigation(scope.row)">{{scope.row.projectNumber}}</a>
            </template>
          </el-table-column> -->
          <el-table-column prop="projectName" :label="$t('projectName')" align="left" :show-overflow-tooltip="true" min-width="280">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleNavigation(scope.row)">{{scope.row.projectName}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="projectType" :label="$t('projectType')" align="center" :show-overflow-tooltip="true" min-width="200"></el-table-column>
          <el-table-column prop="projectStatus" :label="$t('projectStatus')" align="center" :show-overflow-tooltip="true" min-width="150"></el-table-column>
          <el-table-column prop="projectManager" :label="$t('projectManager')" align="center" :show-overflow-tooltip="true" min-width="160"></el-table-column>
          <!-- <el-table-column prop="upstreamSystemId" :label="$t('upstreamSystemId')" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="serviceContractNo" :label="$t('serviceContractNo')" align="center" :show-overflow-tooltip="true"></el-table-column> -->
          <el-table-column prop="taskNum" :label="$t('taskNum')" align="center" min-width="90">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleTask(scope.row)">{{scope.row.taskNum}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="subtaskNum" :label="$t('subtaskNum')" align="center" min-width="120">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleSubtask(scope.row)">{{scope.row.subtaskNum}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="labourSum" :label="$t('labourSum')" align="center" :show-overflow-tooltip="true" min-width="140">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleLabour(scope.row)">{{scope.row.labourSum}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="country" :label="$t('country')" align="center" :show-overflow-tooltip="true" min-width="100"></el-table-column>
          <el-table-column prop="projectStartDate" :label="$t('projectStartDate')" align="center" :show-overflow-tooltip="true" min-width="165"></el-table-column>
          <el-table-column prop="projectEndDate" :label="$t('projectEndDate')" align="center" :show-overflow-tooltip="true" min-width="165"></el-table-column>
          <el-table-column :label="$t('operate')" fixed="right" width="130" align="center">
            <template slot-scope="scope">
              <el-dropdown trigger="click" v-if="scope.row.flagStatus!='3'">
                <el-button size="mini" type="primary">{{$t('operate')}}<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item><el-button v-has="{class:'projectTask'}" v-if="scope.row.flagStatus=='0'&&scope.row.taskQty!='0'" size="mini" type="primary" @click="addTask(scope.row)">{{$t('addTask')}}</el-button></el-dropdown-item>
                  <el-dropdown-item><el-button v-has="{class:'projectUpdate'}" v-if="scope.row.flagStatus=='0'" size="mini" type="primary" @click="handleEdit(scope.row)">{{$t('update')}}</el-button></el-dropdown-item>
                  <el-dropdown-item><el-button v-has="{class:'projectFreeze'}" v-if="scope.row.flagStatus=='0'" size="mini" type="danger" @click="handleFreeze(scope.row)">{{$t('freeze')}}</el-button></el-dropdown-item>
                  <el-dropdown-item><el-button v-has="{class:'projectUnfreeze'}" v-if="scope.row.flagStatus=='2'" size="mini" type="danger" @click="handleUnFreeze(scope.row)">{{$t('unFreeze')}}</el-button></el-dropdown-item>
                  <el-dropdown-item><el-button v-has="{class:'projectClosed'}" v-if="scope.row.flagStatus=='2'" size="mini" type="success" @click="handleClosed(scope.row)">{{$t('closed')}}</el-button></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table> 
      </div>
      <div class="pageDiv">
        <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[10, 20,50,100]"
          :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-card>
    <el-card>
      <el-collapse >
        <el-collapse-item name="1">
          <template slot="title"><span style="font-size: 18px;">Frozen/Closed Project List<i class="header-icon el-icon-caret-bottom"></i></span></template>
          <!-- 查询选项 -->
          <Form class="salesmanForm" :label-width="160">
            <FormItem class="form_item" :label="$t('projectName1')">
              <Input clearable v-model="frozenPaName" :placeholder="$t('enter')"/>
            </FormItem>
            <!-- <FormItem class="form_item" :label="$t('projectNumber1')">
              <Input clearable v-model="frozenPaNumber" :placeholder="$t('enter')"/>
            </FormItem> -->
            <FormItem class="form_item" :label="$t('projectID')">
              <Input clearable v-model="frozenUpstreamSystemId" :placeholder="$t('enter')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('serviceContractNo2')">
              <Input clearable v-model="frozenContractNo" :placeholder="$t('enter')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('projectType1')">
              <el-select filterable v-model="frozenPaType" clearable :placeholder="$t('select')">
                <el-option v-for="item in ProjectTypeList" :key="item.sysDesc" :label="item.sysValue" :value="item.sysDesc">
                </el-option>
              </el-select>
            </FormItem>
            <FormItem class="form_item" :label="$t('country1')">
              <el-select filterable v-model="frozenCountry" clearable :placeholder="$t('select')">
                <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
              </el-select>
            </FormItem>
            <FormItem class="form_item" :label="$t('customerName1')">
              <Input clearable v-model="frozenCuName" :placeholder="$t('enter')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('projectManager1')" v-if="filterShow">
              <el-select v-model="frozenPaManager" clearable filterable remote :remote-method="value => remoteMethod('FrozenManagerList', value)" :placeholder="$t('select')">
                <el-option v-for="(item, index) in FrozenManagerList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
              </el-select>
            </FormItem>
            <FormItem class="form_item" :label="$t('projectStatus1')" v-if="filterShow">
              <el-select v-model="frozenPaStatus" clearable>
                <el-option v-for="item in FrozenStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </FormItem>
            <FormItem class="form_item" :label="$t('projectStartDate1')" v-if="filterShow">
              <el-date-picker v-model="frozenPaStartDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('selectdate')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('projectEndDate1')" v-if="filterShow">
              <el-date-picker v-model="frozenPaEndDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('selectdate')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('finalBeneficialDept1')" v-if="filterShow">
              <el-select v-model="frozenBeneficialDept" clearable filterable remote :remote-method="value => remoteMethodDept('FrozenBeneficialDeptList', value)">
                <el-option v-for="(item, index) in FrozenBeneficialDeptList" :key="index" :label="item.deptEnName" :value="item.deptEnName"></el-option>
              </el-select>
            </FormItem>
            <FormItem class="form_item" :label="$t('csiAccountCode1')" v-if="filterShow">
              <Input clearable v-model="frozenCsiAccountCode" :placeholder="$t('enter')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('beltAndRoad1')" v-if="filterShow">
              <el-select v-model="frozenBeltAndRoad" clearable>
                <el-option v-for="item in BeltAndRoadList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </FormItem>
            <FormItem class="form_item" :label="$t('department1')" v-if="filterShow">
              <el-select filterable v-model="frozenDepartment" clearable>
                <el-option v-for="item in DeptList" :key="item.deptCode" :label="item.deptEnName" :value="item.deptCode"></el-option>
              </el-select>
            </FormItem>
            <!-- <FormItem class="form_item" :label="$t('upstreamSystemId1')" v-if="filterShow">
              <Input clearable v-model="frozenUpstreamSystemId" :placeholder="$t('enter')"/>
            </FormItem> -->
            <div class="buttonDiv">
              <el-button type="primary" size="mini" @click="frozenFilter">{{$t('advancedFilter')}}</el-button>
              <el-button type="primary" size="mini" @click="searchFrozenProjectList" :loading="searchFrozenLoading">{{$t('search')}}</el-button>
              <el-button v-has="{class:'projectExport'}" type="primary" size="mini" @click="frozenExcel">{{$t('export')}}</el-button>
            </div>
          </Form>
          <div class="contentTableDiv">
            <el-table :data="FrozenData" @selection-change="frozenSelectionChange" border style="width:100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column prop="projectName" :label="$t('projectName')" align="left" :show-overflow-tooltip="true" min-width="280">
                <template slot-scope="scope">
                  <a style="color:blue;" @click="handleNavigation(scope.row)">{{scope.row.projectName}}</a>
                </template>
              </el-table-column>
              <el-table-column prop="projectType" :label="$t('projectType')" align="center" :show-overflow-tooltip="true" min-width="200"></el-table-column>
              <el-table-column prop="projectStatus" :label="$t('projectStatus')" align="center" :show-overflow-tooltip="true" min-width="150"></el-table-column>
              <el-table-column prop="projectManager" :label="$t('projectManager')" align="center" :show-overflow-tooltip="true" min-width="160"></el-table-column>
              <el-table-column prop="taskNum" :label="$t('taskNum')" align="center" min-width="90">
                <template slot-scope="scope">
                  <a style="color:blue;" @click="handleTask(scope.row)">{{scope.row.taskNum}}</a>
                </template>
              </el-table-column>
              <el-table-column prop="subtaskNum" :label="$t('subtaskNum')" align="center" min-width="120">
                <template slot-scope="scope">
                  <a style="color:blue;" @click="handleSubtask(scope.row)">{{scope.row.subtaskNum}}</a>
                </template>
              </el-table-column>
              <el-table-column prop="labourSum" :label="$t('labourSum')" align="center" :show-overflow-tooltip="true" min-width="140">
                <template slot-scope="scope">
                  <a style="color:blue;" @click="handleLabour(scope.row)">{{scope.row.labourSum}}</a>
                </template>
              </el-table-column>
              <el-table-column prop="country" :label="$t('country')" align="center" :show-overflow-tooltip="true" min-width="100"></el-table-column>
              <el-table-column prop="projectStartDate" :label="$t('projectStartDate')" align="center" :show-overflow-tooltip="true" min-width="165"></el-table-column>
              <el-table-column prop="projectEndDate" :label="$t('projectEndDate')" align="center" :show-overflow-tooltip="true" min-width="165"></el-table-column>
              <el-table-column :label="$t('operate')" fixed="right" width="130" align="center">
                <template slot-scope="scope">
                  <el-dropdown trigger="click" v-if="scope.row.flagStatus!='3'">
                    <el-button size="mini" type="primary">{{$t('operate')}}<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item><el-button v-has="{class:'projectUnfreeze'}" v-if="scope.row.flagStatus=='2'" size="mini" type="danger" @click="handleUnFreeze(scope.row)">{{$t('unFreeze')}}</el-button></el-dropdown-item>
                      <el-dropdown-item><el-button v-has="{class:'projectClosed'}" v-if="scope.row.flagStatus=='2'" size="mini" type="success" @click="handleClosed(scope.row)">{{$t('closed')}}</el-button></el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table> 
          </div>
          <div class="pageDiv">
            <el-pagination small @size-change="changeFrozenPageSize" @current-change="changeFrozenPage" :current-page="currentFrozenPage" :page-sizes="[10, 20,50,100]"
              :page-size="pageFrozenSize" layout="total, prev, pager, next, sizes, jumper" :total="totalFrozenCount">
            </el-pagination>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <Modal v-model="modelFreeze" :closable='true' :mask-closable='false' :title="$t('freezingReason')">
      <div slot="footer">
        <Button type="primary" size="small" @click="close">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="submitFreezeForm('freezeForm')">{{$t('confrim')}}</Button>
      </div>
      <el-form :model="freezeForm" ref="freezeForm" :rules="rules" >
          <el-row>
            <el-col :xs="24" :md="24">
              <el-form-item prop="freezingReason" >
                <el-input v-model="freezeForm.freezingReason" type="textarea" :rows="4" :placeholder="$t('reason')"/>
              </el-form-item>
            </el-col>
          </el-row>
      </el-form>
    </Modal>
    <Modal v-model="modelUnFreeze" :closable='true' :mask-closable='false' :title="$t('unFreezingReason')">
      <div slot="footer">
        <Button type="primary" size="small" @click="close">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="submitUnFreezeForm('unFreezeForm')">{{$t('confrim')}}</Button>
      </div>
      <el-form :model="unFreezeForm" ref="unFreezeForm" :rules="rules" >
          <el-row>
            <el-col :xs="24" :md="24">
              <el-form-item prop="unFreezingReason" >
                <el-input v-model="unFreezeForm.unFreezingReason" type="textarea" :rows="4" :placeholder="$t('reason')"/>
              </el-form-item>
            </el-col>
          </el-row>
      </el-form>
    </Modal>
    <Modal v-model="modelBatch" :closable='true' :mask-closable='false' :title="$t('batchEdit')">
      <div slot="footer">
        <Button type="primary" size="small" @click="close">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="submitBatchForm('batchForm')">{{$t('confrim')}}</Button>
      </div>
      <el-form :model="batchForm" ref="batchForm" :rules="rules">
          <el-row>
            <el-col :xs="24" :md="24">
              <el-form-item :label="$t('deputyProjectManager1')" prop="deputyProjectManager" >
                <el-select v-model="batchForm.deputyProjectManager" clearable filterable remote :remote-method="value => remoteMethod('DeputyManagerList', value)" style="width: 270px;">
                  <el-option v-for="(item, index) in DeputyManagerList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
      </el-form>
    </Modal>
    <Modal v-model="modelBatchTransfer" :closable='true' :mask-closable='false' title="Batch Transfer">
      <div slot="footer">
        <Button type="primary" size="small" @click="closeBatchTransfer">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="submitBatchTransferForm()">{{$t('confrim')}}</Button>
      </div>
      <p style="color: red; font-weight: bolder; font-size: 17px">
        <i class="el-icon-warning-outline"></i>
        {{this.multipleSelection.length === 0 ? '  Please search or choose the item first. otherwise, you will transfer all the projects.': ' You choosed '+ this.multipleSelection.length +' items.'}}
      </p>
      <el-form :model="batchTransferForm" ref="batchTransferForm" :rules="rules">
          <el-row>
            <el-col :xs="24" :md="24">
              <el-form-item label="New Project Manager:" prop="deputyProjectManager" >
                <el-select v-model="batchTransferForm.deputyProjectManager" clearable filterable remote :remote-method="value => remoteMethod('DeputyManagerList', value)" style="width: 270px;">
                  <el-option v-for="(item, index) in DeputyManagerList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
      </el-form>
    </Modal>
  </div>
</template>
<script>
    import {_debounce} from '@/utils/selectAPI'
    import * as validate from '@/utils/validate'

    export default {
        name: 'project',
        activated () {
          let refresh = this.$route.params.refresh;
          if(refresh == 1){
            this.getProjectByPage();
          }
        },
        created () {
          // this.getParams();
          this.getProjectByPage();
          this.getCountry();
          this.getDeptList();
          this.getProjectTypeList();
          this.getFrozenProjectList();
        },
        data () {
          return {
            rangeNumber: 10,
            projectName:null,
            projectNumber:null,
            serviceContractNo:null,
            projectType:null,
            country:null,
            customerName:null,
            projectManager:null,
            projectStatus:null,
            projectStartDate:null,
            projectEndDate:null,
            finalBeneficialDept:null,
            csiAccountCode:null,
            beltAndRoad:null,
            department:null,
            upstreamSystemId:null,
            presaleKeyProject:null,
            postsaleKeyProject:null,
            //Frozen
            frozenPaName:null,
            frozenPaNumber:null,
            frozenContractNo:null,
            frozenPaType:null,
            frozenCountry:null,
            frozenCuName:null,
            frozenPaManager:null,
            frozenPaStatus:null,
            frozenPaStartDate:null,
            frozenPaEndDate:null,
            frozenBeneficialDept:null,
            frozenCsiAccountCode:null,
            frozenBeltAndRoad:null,
            frozenDepartment:null,
            frozenUpstreamSystemId:null,
            //other
            projectId:null,
            pjNumber:null,
            ProjectTypeList:[],
            freezeForm:{
              freezingReason:null,
            },
            unFreezeForm:{
              unFreezingReason:null,
            },
            batchForm:{
              deputyProjectManager:null,
            },
            BeltAndRoadList:[
              { value: 'Yes',label: 'Yes'},
              { value: 'No',label: 'No'},
            ],
            StatusList:[
              { value: 'ToDelivered',label: 'Waiting for Delivery'},
              { value: 'Delivered',label: 'Delivering'},
              { value: 'PartialDelivery',label: 'Partially delivered'},
              { value: 'DeliveryCompleted',label: 'Fully Delivered'},
            ],
            FrozenStatus:[
              { value: 'Frozen',label: 'Frozen'},
              { value: 'Closed',label: 'Closed'},
            ],
            PresaleKeyProjectList:[
              { value: 'Yes',label: 'Yes'},
              { value: 'No',label: 'No'},
            ],
            PostsaleKeyProjectList:[
              { value: 'Normal',label: 'Normal'},
              { value: 'Department',label: 'Department'},
              { value: 'Corp',label: 'Corp'},
            ],
            ProjectManagerList:[],
            FrozenManagerList:[],
            DeputyManagerList:[],
            DeptList:[],
            DepartmentList:[],
            FinalBeneficialDeptList:[],
            FrozenBeneficialDeptList:[],
            queryShow:false,
            filterShow:false,
            exportLoading:false,
            modelFreeze:false,
            modelUnFreeze:false,
            modelBatch:false,
            currentPage: 1,
            totalCount: 0,
            pageSize: 10,
            multipleSelection: [],
            frozenSelection: [],
            tableData: [],
            CountryList: [],
            FrozenData: [],
            currentFrozenPage: 1,
            totalFrozenCount: 0,
            pageFrozenSize: 10,
            rules: {
              freezingReason: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              unFreezingReason: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              deputyProjectManager: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
            },
            modelBatchTransfer: false,
            batchTransferForm:{
              deputyProjectManager:null,
            },
            searchLoading: false,
            searchFrozenLoading: false,
          }
        },
        methods: {
          getParams(){
            let id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
              let params = this.$route.params;
              this.currentPage = params.currentPage;
              this.pageSize = params.pageSize;
              this.projectName = params.projectName;
              this.projectNumber = params.projectNumber;
              this.projectType = params.projectType;
              this.serviceContractNo = params.serviceContractNo;
              this.country = params.country;
              this.customerName = params.customerName;
              this.projectManager = params.projectManager;
              this.projectStatus = params.projectStatus;
              this.projectStartDate = params.projectStartDate;
              this.projectEndDate = params.projectEndDate;
              this.finalBeneficialDept = params.finalBeneficialDept;
              this.csiAccountCode = params.csiAccountCode;
              this.beltAndRoad = params.beltAndRoad;
              this.department = params.department;
              this.upstreamSystemId = params.upstreamSystemId;
            }
          },
          remoteMethod(list, query) {
            if (query !== '') {
              // 清除之前的定时器
              if (this.timeout) {
                clearTimeout(this.timeout)
              }
              // 防抖处理，300ms后执行
              this.timeout = setTimeout(() => {
                this.fetchUserOptions(list, query)
              }, 200)
            } else {
              this[list] = [];
            }
          },
          fetchUserOptions(list, query) {
            let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
            this._get(url).then().then(res => {
              if(res.code === 200 && res.data) {
                this[list] = res.data;
              } else {
                this[list] = [];
              }
            }).catch(error => {
              this[list] = [];
              console.error('搜索失败:', error)
            })
          },
          getCountry(){
            let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
            let pm = {
              sysKey: 'Country',
              delFlg: '0',
            }
            this._post(url,pm).then(
              res => {   
                this.CountryList = res.data;
              }
            )
          },
          getDeptList(){
            let url =`${this.$store.state.islhurl}dept/getSelectData`;
            let pm = {
              deptCodechain: 'SelectDept',
            }
            this._post(url,pm).then(
              res => {   
                this.DeptList = res.data;
              }
            )
          },
          remoteMethodDept(list, query) {
            if (query !== '') {
              // 清除之前的定时器
              if (this.timeout) {
                clearTimeout(this.timeout)
              }
              // 防抖处理，300ms后执行
              this.timeout = setTimeout(() => {
                this.fetchDeptOptions(list, query)
              }, 200)
            } else {
              this[list] = [];
            }
          },
          fetchDeptOptions(list, query) {
            let url =`${this.$store.state.islhurl}dept/select-option?keyword=${query}`;
            this._get(url).then().then(res => {
              if(res.code === 200 && res.data) {
                this[list] = res.data;
              } else {
                this[list] = [];
              }
            }).catch(error => {
              this[list] = [];
              console.error('搜索失败:', error)
            })
          },
          getProjectTypeList(){
            let url = `${this.$store.state.islhurl}keyValue/getSelectData`
            let pm = {
              sysKey: 'ProjectType',
            }
            this._post(url,pm).then(
              res =>{
                this.ProjectTypeList = res.data;
              }
            )
          },
          getProjectByPage(){
            let url = `${this.$store.state.islhurl}getProjectInfo/${this.pageSize}/${this.currentPage}`
            let pm = {
              projectName: this.projectName==''?null:this.projectName,
              projectNumber: this.projectNumber==''?null:this.projectNumber,
              projectType: this.projectType==''?null:this.projectType,
              serviceContractNo: this.serviceContractNo==''?null:this.serviceContractNo,
              country: this.country==''?null:this.country,
              customerName: this.customerName==''?null:this.customerName,
              projectManager: this.projectManager==''?null:this.projectManager,
              projectStatus: this.projectStatus==''?null:this.projectStatus,
              projectStartDate: this.projectStartDate==''?null:this.projectStartDate,
              projectEndDate: this.projectEndDate==''?null:this.projectEndDate,
              finalBeneficialDept: this.finalBeneficialDept==''?null:this.finalBeneficialDept,
              csiAccountCode: this.csiAccountCode==''?null:this.csiAccountCode,
              beltAndRoad: this.beltAndRoad==''?null:this.beltAndRoad,
              department: this.department==''?null:this.department,
              upstreamSystemId : this.upstreamSystemId==''?null:this.upstreamSystemId,
              presaleKeyProject : this.presaleKeyProject==''?null:this.presaleKeyProject,
              postsaleKeyProject : this.postsaleKeyProject==''?null:this.postsaleKeyProject,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res =>{
                this.tableData =res.data;
                this.totalCount = res.totalNums;
              }
            )
          },
          searchProjectByPage(){
            this.pageSize = 10;
            this.currentPage = 1;
            let url = `${this.$store.state.islhurl}getProjectInfo/${this.pageSize}/${this.currentPage}`
            let pm = {
              projectName: this.projectName==''?null:this.projectName,
              projectNumber: this.projectNumber==''?null:this.projectNumber,
              projectType: this.projectType==''?null:this.projectType,
              serviceContractNo: this.serviceContractNo==''?null:this.serviceContractNo,
              country: this.country==''?null:this.country,
              customerName: this.customerName==''?null:this.customerName,
              projectManager: this.projectManager==''?null:this.projectManager,
              projectStatus: this.projectStatus==''?null:this.projectStatus,
              projectStartDate: this.projectStartDate==''?null:this.projectStartDate,
              projectEndDate: this.projectEndDate==''?null:this.projectEndDate,
              finalBeneficialDept: this.finalBeneficialDept==''?null:this.finalBeneficialDept,
              csiAccountCode: this.csiAccountCode==''?null:this.csiAccountCode,
              beltAndRoad: this.beltAndRoad==''?null:this.beltAndRoad,
              department: this.department==''?null:this.department,
              upstreamSystemId : this.upstreamSystemId==''?null:this.upstreamSystemId,
              presaleKeyProject : this.presaleKeyProject==''?null:this.presaleKeyProject,
              postsaleKeyProject : this.postsaleKeyProject==''?null:this.postsaleKeyProject,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this.searchLoading = true
            this._post(url,pm).then(
              res =>{
                this.tableData =res.data;
                this.totalCount = res.totalNums;
                this.searchLoading = false
              }
            ).catch(e => {
              this.searchLoading = false
            })
          },
          getFrozenProjectList(){
            let url = `${this.$store.state.islhurl}getFrozenProjectList/${this.pageFrozenSize}/${this.currentFrozenPage}`
            let pm = {
              projectName: this.frozenPaName==''?null:this.frozenPaName,
              projectNumber: this.frozenPaNumber==''?null:this.frozenPaNumber,
              projectType: this.frozenPaType==''?null:this.frozenPaType,
              serviceContractNo: this.frozenContractNo==''?null:this.frozenContractNo,
              country: this.frozenCountry==''?null:this.frozenCountry,
              customerName: this.frozenCuName==''?null:this.frozenCuName,
              projectManager: this.frozenPaManager==''?null:this.frozenPaManager,
              projectStatus: this.frozenPaStatus==''?null:this.frozenPaStatus,
              projectStartDate: this.frozenPaStartDate==''?null:this.frozenPaStartDate,
              projectEndDate: this.frozenPaEndDate==''?null:this.frozenPaEndDate,
              finalBeneficialDept: this.frozenBeneficialDept==''?null:this.frozenBeneficialDept,
              csiAccountCode: this.frozenCsiAccountCode==''?null:this.frozenCsiAccountCode,
              beltAndRoad: this.frozenBeltAndRoad==''?null:this.frozenBeltAndRoad,
              department: this.frozenDepartment==''?null:this.frozenDepartment,
              upstreamSystemId : this.frozenUpstreamSystemId==''?null:this.frozenUpstreamSystemId,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res =>{
                this.FrozenData = res.data;
                this.totalFrozenCount = res.totalNums;
              }
            )
          },
          searchFrozenProjectList(){
            this.pageFrozenSize = 10;
            this.currentFrozenPage = 1;
            let url = `${this.$store.state.islhurl}getFrozenProjectList/${this.pageFrozenSize}/${this.currentFrozenPage}`
            let pm = {
              projectName: this.frozenPaName==''?null:this.frozenPaName,
              projectNumber: this.frozenPaNumber==''?null:this.frozenPaNumber,
              projectType: this.frozenPaType==''?null:this.frozenPaType,
              serviceContractNo: this.frozenContractNo==''?null:this.frozenContractNo,
              country: this.frozenCountry==''?null:this.frozenCountry,
              customerName: this.frozenCuName==''?null:this.frozenCuName,
              projectManager: this.frozenPaManager==''?null:this.frozenPaManager,
              projectStatus: this.frozenPaStatus==''?null:this.frozenPaStatus,
              projectStartDate: this.frozenPaStartDate==''?null:this.frozenPaStartDate,
              projectEndDate: this.frozenPaEndDate==''?null:this.frozenPaEndDate,
              finalBeneficialDept: this.frozenBeneficialDept==''?null:this.frozenBeneficialDept,
              csiAccountCode: this.frozenCsiAccountCode==''?null:this.frozenCsiAccountCode,
              beltAndRoad: this.frozenBeltAndRoad==''?null:this.frozenBeltAndRoad,
              department: this.frozenDepartment==''?null:this.frozenDepartment,
              upstreamSystemId : this.frozenUpstreamSystemId==''?null:this.frozenUpstreamSystemId,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this.searchFrozenLoading = true
            this._post(url,pm).then(
              res =>{
                this.FrozenData = res.data;
                this.totalFrozenCount = res.totalNums;
                this.searchFrozenLoading = false
              }
            ).catch(e => {
              this.searchFrozenLoading = false
            })
          },
          addInfo() {
            this.$router.push({path:'/project/add'});
          },
          sourceInfo(){
            this.$router.push({path:'/ipmsSource'});
            this.$store.commit('tagChange', 'ipmsSource');
          },
          handleNavigation(index){
            let pm = {
              id: index.id,
              showRun:'Y',
            }
            this.$router.push({name:'project_detail',params:pm})
          },
          handleTask(index){
            let pm = {
              projectNumber: index.projectNumber,
              toTask: 'N',
            }
            this.$router.push({name:'task',params:pm});
            this.$store.commit('tagChange', 'task');
          },
          handleSubtask(index){
            let pm = {
              projectNumber: index.projectNumber,
              toSubtask: 'N',
            }
            this.$router.push({name:'subtask',params:pm});
            this.$store.commit('tagChange', 'subtask');
          },
          handleLabour(index){
            let pm = {
              projectNumber: index.projectNumber,
              toLabour: 'N',
            }
            this.$router.push({name:'labour',params:pm});
            this.$store.commit('tagChange', 'labour');
          },
          addTask(index) {
            let pm = {
              projectNumber: index.projectNumber,
            }
            this.$router.push({name:'task_add',params:pm})
          },
          handleEdit(index) {
            let pm = {
              id: index.id,
            }
            this.$router.push({name:'project_edit',params:pm})
          },
          handleFreeze(index){
            this.projectId = index.id;
            this.pjNumber = index.projectNumber;
            this.freezeForm.freezingReason = null;
            this.modelFreeze = true;
          },
          submitFreezeForm(formName){
            this.$refs[formName].validate((valid) => {
              if (valid) {
                this.freezeInfo();
              } else {
                return false;
              }
            });
          },
          freezeInfo(){
            let params = {
              id:this.projectId,
              projectNumber:this.pjNumber,
              freezingReason:this.freezeForm.freezingReason,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            let url = `${this.$store.state.islhurl}project/freezeInfo`
            this._post(url,params).then(
              res => {
                if(res=="200"){
                  this.getProjectByPage();
                  this.getFrozenProjectList();
                  this.modelFreeze = false;
                  this.$Message.success('Freeze successful' )
                }else{
                  this.$message.error(res);
                }
              }
            )
          },
          handleUnFreeze(index){
            this.projectId = index.id;
            this.pjNumber = index.projectNumber;
            this.unFreezeForm.unFreezingReason = null;
            this.modelUnFreeze = true;
          },
          submitUnFreezeForm(formName){
            this.$refs[formName].validate((valid) => {
              if (valid) {
                this.unFreezeInfo();
              } else {
                return false;
              }
            });
          },
          unFreezeInfo(){
            let params = {
              id:this.projectId,
              projectNumber:this.pjNumber,
              unfreezingReason:this.unFreezeForm.unFreezingReason,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            let url = `${this.$store.state.islhurl}project/unFreezeInfo`
            this._post(url,params).then(
              res => {
                if(res=="200"){
                  this.getProjectByPage();
                  this.getFrozenProjectList();
                  this.modelUnFreeze = false;
                  this.$Message.success('unFreeze successful' )
                }else{
                  this.$message.error(res);
                }
              }
            )
          },
          handleClosed(index){
            this.$confirm("Are you sure to close the project", "Warning", {
              confirmButtonText: 'Confirm',
              cancelButtonText: 'Cancel',
              type: 'warning'
            }).then(() => {
              let params = {
                id:index.id,
                projectName:index.projectName,
                projectNumber:index.projectNumber,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
              let url = `${this.$store.state.islhurl}project/closeInfo`
              this._post(url,params).then(
                res =>{
                  if(res=="200"){
                    this.getFrozenProjectList();
                    this.$Message.success('Project Close Successful' )
                  }else{
                    this.$message.error(res);
                  }
                }
              )
            }).catch(() => {
            });
          },
          handleSelectionChange(val) {
            this.multipleSelection = val;
          },
          batchInfo(){
            const length = this.multipleSelection.length;
            if(length == 0){
              this.$message.warning('Please choose the data first！');
              return;
            }
            this.batchForm.deputyProjectManager = null;
            this.modelBatch = true;
          },
          submitBatchForm(formName){
            this.$refs[formName].validate((valid) => {
              if (valid) {
                this.batchEditInfo();
              } else {
                return false;
              }
            });
          },
          batchEditInfo(){
            let ids = [];
            const length = this.multipleSelection.length;
            for (let i = 0; i < length; i++) {
              ids.push(this.multipleSelection[i].id)
            }
            let params = {
              ids : ids,
              deputyProjectManager : this.batchForm.deputyProjectManager,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            let url = `${this.$store.state.islhurl}project/batchEditInfo`
            this._post(url,params).then(
              res => {
                if(res=="200"){
                  this.getProjectByPage();
                  this.modelBatch = false;
                  this.$Message.success('batch edit successful' )
                }else{
                  this.$message.error(res);
                }
              }
            )
          },
          exportExcel(){
            this.exportLoading = true;
            let execlName = 'ProjectInfo.xlsx';
            const length = this.multipleSelection.length;
            let ids = [];
            for (let i = 0; i < length; i++) {
              ids.push(this.multipleSelection[i].id)
            }
            this.$axios({
              url: `${this.$store.state.islhurl}project/exportInfo`,
              method: 'post',
              data: {
                ids: ids,
                projectName: this.projectName==''?null:this.projectName,
                projectNumber: this.projectNumber==''?null:this.projectNumber,
                projectType: this.projectType==''?null:this.projectType,
                serviceContractNo: this.serviceContractNo==''?null:this.serviceContractNo,
                country: this.country==''?null:this.country,
                customerName: this.customerName==''?null:this.customerName,
                projectManager: this.projectManager==''?null:this.projectManager,
                projectStatus: this.projectStatus==''?null:this.projectStatus,
                projectStartDate: this.projectStartDate==''?null:this.projectStartDate,
                projectEndDate: this.projectEndDate==''?null:this.projectEndDate,
                finalBeneficialDept: this.finalBeneficialDept==''?null:this.finalBeneficialDept,
                csiAccountCode: this.csiAccountCode==''?null:this.csiAccountCode,
                beltAndRoad: this.beltAndRoad==''?null:this.beltAndRoad,
                department: this.department==''?null:this.department,
                upstreamSystemId : this.upstreamSystemId==''?null:this.upstreamSystemId,
                presaleKeyProject : this.presaleKeyProject==''?null:this.presaleKeyProject,
                postsaleKeyProject : this.postsaleKeyProject==''?null:this.postsaleKeyProject,
                islhToken : sessionStorage.getItem('islhtoken'),
              },
              responseType:"blob"
            }).then(response=>{
              this.exportLoading = false;
              const blob = new Blob([response.data])
              const aEle = document.createElement('a');     // 创建a标签
              const href = window.URL.createObjectURL(blob);       // 创建下载的链接
              aEle.href = href;
              aEle.download = execlName;  // 下载后文件名
              document.body.appendChild(aEle);
              aEle.click();     // 点击下载 
              document.body.removeChild(aEle); // 下载完成移除元素
              window.URL.revokeObjectURL(href) // 释放掉blob对象
            })
          },
          frozenSelectionChange(val) {
            this.frozenSelection = val;
          },
          frozenExcel(){
            this.exportLoading = true;
            let execlName = 'ProjectInfo.xlsx';
            const length = this.frozenSelection.length;
            let ids = [];
            for (let i = 0; i < length; i++) {
              ids.push(this.frozenSelection[i].id)
            }
            this.$axios({
              url: `${this.$store.state.islhurl}project/exportFrozenExcel`,
              method: 'post',
              data: {
                ids: ids,
                projectName: this.frozenPaName==''?null:this.frozenPaName,
                projectNumber: this.frozenPaNumber==''?null:this.frozenPaNumber,
                projectType: this.frozenPaType==''?null:this.frozenPaType,
                serviceContractNo: this.frozenContractNo==''?null:this.frozenContractNo,
                country: this.frozenCountry==''?null:this.frozenCountry,
                customerName: this.frozenCuName==''?null:this.frozenCuName,
                projectManager: this.frozenPaManager==''?null:this.frozenPaManager,
                projectStatus: this.frozenPaStatus==''?null:this.frozenPaStatus,
                projectStartDate: this.frozenPaStartDate==''?null:this.frozenPaStartDate,
                projectEndDate: this.frozenPaEndDate==''?null:this.frozenPaEndDate,
                finalBeneficialDept: this.frozenBeneficialDept==''?null:this.frozenBeneficialDept,
                csiAccountCode: this.frozenCsiAccountCode==''?null:this.frozenCsiAccountCode,
                beltAndRoad: this.frozenBeltAndRoad==''?null:this.frozenBeltAndRoad,
                department: this.frozenDepartment==''?null:this.frozenDepartment,
                upstreamSystemId : this.frozenUpstreamSystemId==''?null:this.frozenUpstreamSystemId,
                islhToken : sessionStorage.getItem('islhtoken'),
              },
              responseType:"blob"
            }).then(response=>{
              this.exportLoading = false;
              const blob = new Blob([response.data])
              const aEle = document.createElement('a');     // 创建a标签
              const href = window.URL.createObjectURL(blob);       // 创建下载的链接
              aEle.href = href;
              aEle.download = execlName;  // 下载后文件名
              document.body.appendChild(aEle);
              aEle.click();     // 点击下载 
              document.body.removeChild(aEle); // 下载完成移除元素
              window.URL.revokeObjectURL(href) // 释放掉blob对象
            })
          },
          close(){
            this.$refs.freezeForm.resetFields();
            this.$refs.unFreezeForm.resetFields();
            this.$refs.batchForm.resetFields();
            this.modelFreeze = false;
            this.modelUnFreeze = false;
            this.modelBatch = false;
          },
          advancedFilter(){
            if(this.queryShow){
              this.queryShow = false;
              this.projectManager = null;
              this.projectStatus = null;
              this.projectStartDate = null;
              this.projectEndDate = null;
              this.finalBeneficialDept = null;
              this.csiAccountCode = null;
              this.beltAndRoad = null;
              this.department = null;
              this.upstreamSystemId = null;
              this.presaleKeyProject = null;
              this.postsaleKeyProject = null;
            }else{
              this.queryShow = true;
            }
          },
          frozenFilter(){
            if(this.filterShow){
              this.filterShow = false;
              this.frozenPaManager = null;
              this.frozenPaStatus = null;
              this.frozenPaStartDate = null;
              this.frozenPaEndDate = null;
              this.frozenBeneficialDept = null;
              this.frozenCsiAccountCode = null;
              this.frozenBeltAndRoad = null;
              this.frozenDepartment = null;
              this.frozenUpstreamSystemId = null;
            }else{
              this.filterShow = true;
            }
          },
          changePage (val) {
            this.currentPage = val;
            this.getProjectByPage();
          },
          // 改变当前页显示条数
          changePageSize (val) {
            this.pageSize = val;
            this.getProjectByPage();
          },
          changeFrozenPage (val) {
            this.currentFrozenPage = val;
            this.getFrozenProjectList();
          },
          changeFrozenPageSize (val) {
            this.pageFrozenSize = val;
            this.getFrozenProjectList();
          },
          loadMore(n) {
            // n是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
            // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
            return () => (this.rangeNumber += 5); // 每次滚动到底部可以新增条数,可自定义
          },
          batchTransfer() {
            // if(this.multipleSelection.length === 0 && !this.projectManager) {
            //   this.$message.warning('Please search for the project manager first！');
            //   return;
            // }
            this.batchTransferForm.deputyProjectManager = null;
            this.modelBatchTransfer = true;
          },
          closeBatchTransfer() {
            this.$refs.batchTransferForm.resetFields();
            this.modelBatchTransfer = false;
          },
          submitBatchTransferForm() {
            this.$refs.batchTransferForm.validate((valid) => {
              if (valid) {
                let params = {
                  islhToken : sessionStorage.getItem('islhtoken'),
                  empCode: this.batchTransferForm.deputyProjectManager,
                }
                if(this.multipleSelection.length === 0) {
                  params = {
                    ...params,
                    projectName: this.projectName==''?null:this.projectName,
                    projectNumber: this.projectNumber==''?null:this.projectNumber,
                    projectType: this.projectType==''?null:this.projectType,
                    serviceContractNo: this.serviceContractNo==''?null:this.serviceContractNo,
                    country: this.country==''?null:this.country,
                    customerName: this.customerName==''?null:this.customerName,
                    projectManager: this.projectManager==''?null:this.projectManager,
                    projectStatus: this.projectStatus==''?null:this.projectStatus,
                    projectStartDate: this.projectStartDate==''?null:this.projectStartDate,
                    projectEndDate: this.projectEndDate==''?null:this.projectEndDate,
                    finalBeneficialDept: this.finalBeneficialDept==''?null:this.finalBeneficialDept,
                    csiAccountCode: this.csiAccountCode==''?null:this.csiAccountCode,
                    beltAndRoad: this.beltAndRoad==''?null:this.beltAndRoad,
                    department: this.department==''?null:this.department,
                    upstreamSystemId : this.upstreamSystemId==''?null:this.upstreamSystemId,
                    presaleKeyProject : this.presaleKeyProject==''?null:this.presaleKeyProject,
                    postsaleKeyProject : this.postsaleKeyProject==''?null:this.postsaleKeyProject,
                    batchProjectIdList: null,
                    quantityMark: 1,
                  }
                } else {
                  let ids = [];
                  for (let i = 0; i < this.multipleSelection.length; i++) {
                    ids.push(this.multipleSelection[i].id)
                  }
                  params.batchProjectIdList = ids.join(',');
                  params.quantityMark = 0;
                }
                console.log(params)
                console.log(this.multipleSelection)
                let url = `${this.$store.state.islhurl}project/batchChangeProjectManager`
                this._post(url, params).then(
                  res =>{
                    if(res.code === 200){
                      this.$Message.success('Successful');
                      this.closeBatchTransfer();
                      this.getProjectByPage();
                    } else {
                      this.$message.error(res);
                    }
                  }
                )
              } else {
                return false;
              }
            });
            
          },
        },
        directives:{
          'el-select-loadmore':(el, binding) => {
            // 获取element-ui定义好的scroll盒子
            const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
            if(SELECTWRAP_DOM){
              //解除绑定事件
              el.unbindEventListener = () => {
                SELECTWRAP_DOM.removeEventListener("scroll", function () {
                  const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                  if (condition) binding.value();
                });
              }
              //绑定事件
              SELECTWRAP_DOM.addEventListener("scroll", function () {
                /**
                 * scrollHeight 获取元素内容高度(只读)
                 * scrollTop 获取或者设置元素的偏移值,
                 *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
                 * clientHeight 读取元素的可见高度(只读)
                 * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
                 * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
                 */
                const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                if (condition) binding.value();
              });
            }
          },
        }
    }
</script>



// WEBPACK FOOTER //
// src/view/project/projectList.vue